var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
import { attr } from '@ember-data/model';
export const MAXIMUM_CREDIT_QUANTITY = 1000;

// https://prototype.sqprod.co/#/docs/squareup.credittracking.service.PackStatus
export let CreditPackStatus = /*#__PURE__*/function (CreditPackStatus) {
  CreditPackStatus["ACTIVE"] = "ACTIVE";
  CreditPackStatus["REFUNDED"] = "REFUNDED";
  return CreditPackStatus;
}({});

// https://prototype.sqprod.co/#/docs/squareup.credittracking.service.CreditPack
let CreditPack = (_dec = attr('number'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('string'), _dec6 = attr('string'), _dec7 = attr('string'), _dec8 = attr('number'), _dec9 = attr('number'), _dec10 = attr('string'), _dec11 = attr('string'), _dec12 = attr('string'), _dec13 = attr('number'), _class = class CreditPack extends EmberDataBaseModel {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "catalogVersion", _descriptor, this);
    _initializerDefineProperty(this, "createdAt", _descriptor2, this);
    _initializerDefineProperty(this, "creditPackageId", _descriptor3, this);
    _initializerDefineProperty(this, "creditPolicyId", _descriptor4, this);
    _initializerDefineProperty(this, "customerId", _descriptor5, this);
    _initializerDefineProperty(this, "pricingRuleId", _descriptor6, this);
    _initializerDefineProperty(this, "purchaseOrderId", _descriptor7, this);
    _initializerDefineProperty(this, "quantityAvailable", _descriptor8, this);
    _initializerDefineProperty(this, "quantityPending", _descriptor9, this);
    _initializerDefineProperty(this, "status", _descriptor10, this);
    _initializerDefineProperty(this, "updatedAt", _descriptor11, this);
    _initializerDefineProperty(this, "validityEndsAt", _descriptor12, this);
    _initializerDefineProperty(this, "version", _descriptor13, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "catalogVersion", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "creditPackageId", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "creditPolicyId", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "customerId", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "pricingRuleId", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "purchaseOrderId", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "quantityAvailable", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "quantityPending", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "status", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "validityEndsAt", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "version", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { CreditPack as default };
CreditPack.reopenClass({
  _modelNameForMigration: 'credit-pack'
});